module.exports = __webpack_public_path__ + "img/69.9.TU.ff28ef4e.png";